import { GET_M_SeminarMaster_SelectReducer, M_SeminarMaster_DeleteReducer, POST_M_SeminarMaster_InsertReducer } from "./Slices/Admin/SeminarMasterSlice/SeminarMasterSlice";
import { GET_M_SeminarVideoMaster_SelectReducer, M_SeminarVideoMaster_DeleteReducer, POST_M_SeminarVideoMaster_InsertReducer } from "./Slices/Admin/SeminarVideoMasterSlice/SeminarVideoMasterSlice";
import { GET_M_WebinarMaster_SelectReducer, M_WebinarMaster_DeleteReducer, POST_M_WebinarMaster_InsertReducer } from "./Slices/Admin/WebinarMasterSlice/WebinarMasterSlice";
import { GET_M_WebinarVideoMaster_SelectReducer, M_WebinarVideoMaster_DeleteReducer, POST_M_WebinarVideoMaster_InsertReducer } from "./Slices/Admin/WebinarVideoMasterSlice/WebinarVideoMasterSlice";
import { LicentiateCertificateReducer, LicentiateCertificateSubMenuReducer, MonthDDLReducer, Optional_Subject_ListReducer, Week_Category_ListReducer, YearDDLReducer } from "./Slices/DDLSlice/DDLSlice";
import { ExamFormDetailsPostReducer } from "./Slices/ExamFormDetailsSlice/ExamFormDetailsSlice";
import { Export_ExaminationForm_SelectReducer, GET_T_ExaminationForm_SelectReducer } from "./Slices/GridAPISlice";
import { GET_M_User_SelectReducer, M_User_DeleteReducer, POST_M_User_InsertReducer } from "./Slices/UserCreationSlice/UserCreationSlice";

export const rootreducer = {
    //DDLSlices
    LicentiateCertificateData: LicentiateCertificateReducer,
    LicentiateCertificateSubMenuData: LicentiateCertificateSubMenuReducer,
    Optional_Subject_ListData: Optional_Subject_ListReducer,
    Week_Category_ListData: Week_Category_ListReducer,

    // Slices

    ExamFormDetailsPostData: ExamFormDetailsPostReducer,


    // User Creation 
    POST_M_User_InsertData: POST_M_User_InsertReducer,
    M_User_DeleteData: M_User_DeleteReducer,
    GET_M_User_SelectData: GET_M_User_SelectReducer,

    // Admin

    YearDDLData: YearDDLReducer,
    MonthDDLData: MonthDDLReducer,

    GET_T_ExaminationForm_SelectData: GET_T_ExaminationForm_SelectReducer,
    Export_ExaminationForm_SelectData: Export_ExaminationForm_SelectReducer,

    GET_M_SeminarMaster_SelectData: GET_M_SeminarMaster_SelectReducer,
    POST_M_SeminarMaster_InsertData: POST_M_SeminarMaster_InsertReducer,
    M_SeminarMaster_DeleteData: M_SeminarMaster_DeleteReducer,

    POST_M_WebinarMaster_InsertData: POST_M_WebinarMaster_InsertReducer,
    M_WebinarMaster_DeleteData: M_WebinarMaster_DeleteReducer,
    GET_M_WebinarMaster_SelectData: GET_M_WebinarMaster_SelectReducer,

    POST_M_SeminarVideoMaster_InsertData: POST_M_SeminarVideoMaster_InsertReducer,
    M_SeminarVideoMaster_DeleteData: M_SeminarVideoMaster_DeleteReducer,
    GET_M_SeminarVideoMaster_SelectData: GET_M_SeminarVideoMaster_SelectReducer,

    POST_M_WebinarVideoMaster_InsertData: POST_M_WebinarVideoMaster_InsertReducer,
    M_WebinarVideoMaster_DeleteData: M_WebinarVideoMaster_DeleteReducer,
    GET_M_WebinarVideoMaster_SelectData: GET_M_WebinarVideoMaster_SelectReducer,

};
